import { Skeleton } from "@flixbus/honeycomb-react";
import * as React from "react";
import * as css from "./PagerSkeleton.scss";

const PagerSkeleton: React.FC = () => {
  return (
    <div className={css.skeletonWrapper}>
      <Skeleton flushBottom height="lg" />
      <Skeleton flushBottom height="lg" />
    </div>
  );
};

export default PagerSkeleton;
